import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Barcode from "@/view/pages/partials/Barcode.vue";
import CommonMixin from "@/core/plugins/common-mixin";
import ListingTable from "@/view/pages/partials/Listing-Table.vue";
import ListingFooter from "@/view/pages/partials/Listing-Footer.vue";
import { QUERY } from "@/core/services/store/request.module";
import TableActivity from "@/view/pages/partials/Table-Activity.vue";
import CustomStatus from "@/view/pages/partials/CustomStatus.vue";
export default {
  mixins: [CommonMixin],
  data: function data() {
    return {
      quotationLoading: false,
      rowData: [],
      currentPage: 1,
      status: "all",
      search: null,
      totalPages: 0,
      totalRows: 0,
      rowsOffset: 0
    };
  },
  props: {
    type: {
      type: String,
      default: null
    },
    typeId: {
      type: Number,
      default: 0
    }
  },
  watch: {
    typeId: function typeId() {
      this.getQuotations();
    }
  },
  methods: {
    clearFilter: function clearFilter() {//
    },
    getQuotations: function getQuotations() {
      var _this = this;

      var data = {
        current_page: this.currentPage,
        entity: 0,
        search: this.search,
        status: this.status,
        type: this.type,
        type_id: this.typeId
      };

      if (this.quotationLoading) {
        return false;
      }

      this.quotationLoading = true;
      this.$store.dispatch(QUERY, {
        url: "quotation",
        data: data
      }).then(function (_ref) {
        var data = _ref.data;
        _this.totalPages = Math.ceil(data.total_rows / data.per_page);
        _this.currentPage = data.current_page;
        _this.rowData = data.rows;
        _this.totalRows = data.total_rows;
        _this.rowsOffset = data.offset;
      }).catch(function (error) {
        _this.logError(error);
      }).finally(function () {
        _this.quotationLoading = false;
      });
    },
    routeToQuotation: function routeToQuotation(row) {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.$router.push(_this2.getDefaultRoute("quotation.detail", {
          params: {
            id: row.id
          }
        }));
      });
    }
  },
  computed: {
    showingFrom: function showingFrom() {
      return this.lodash.isEmpty(this.rowData) === false ? this.rowsOffset + 1 : 0;
    },
    showingTo: function showingTo() {
      return this.rowsOffset + (this.rowData ? this.rowData.length : 0);
    }
  },
  mounted: function mounted() {
    this.getQuotations();
  },
  components: {
    Barcode: Barcode,
    ListingFooter: ListingFooter,
    ListingTable: ListingTable,
    TableActivity: TableActivity,
    CustomStatus: CustomStatus
  }
};